import styled from "styled-components";

export const TenantBigScreensWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
    padding: 0px 20px;
    height: 60px;
    overflow-y: auto;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
`;

export const TableWrapper = styled.div`
    flex: 1 1 auto;
    border-radius: 5px;
    overflow: hidden;
`;

export const TablesRow = styled.div`
    display: flex;
    gap: 20px;
    align-items: flex-start;
`;

export const TableColumn = styled.div`
    flex: 0 0 50%;
    max-width: 50%;
`;

export const TitleWrapper = styled.div`
    margin: 10px;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    color: rgba(0,0,0,0.85);
`;
